import React from 'react';
import FinanceRow from './FinanceRow';

const OUTGOING_TYPES = [
  { value: 'PROFORMA_INVOICE', label: 'Pro forma invoices' },
  { value: 'OUTGOING_INVOICE', label: 'Outgoing Invoices' },
  { value: 'CREDIT_NOTE', label: 'Credit Notes' },
];

const INCOMING_TYPES = [
  { value: 'PURCHASE_ORDER', label: 'Purchase Orders' },
  { value: 'INCOMING_INVOICE', label: 'Incoming Invoices' },
  { value: 'DEBIT_NOTE', label: 'Debit Notes' },
];

let tempCounter = 0;
const nextTempId = () => `fc_temp_${++tempCounter}`;

const ActualsSection = ({
  sectionType,
  lines,
  classifications,
  budgetSectionTotal,
  quantity,
  onLineChange,
  onAddRow,
  onRemoveRow,
  fxLoadingMap,
}) => {
  const isOutgoing = sectionType === 'OUTGOING';
  const docTypes = isOutgoing ? OUTGOING_TYPES : INCOMING_TYPES;

  const sectionLines = lines.filter((l) =>
    docTypes.some((dt) => dt.value === l.line_type)
  );

  const computeSubtotal = (field) =>
    sectionLines.reduce((sum, l) => sum + (parseFloat(l[field]) || 0), 0);

  // Doc-type-aware variance: credit/debit notes are added back, invoices/orders subtracted
  const sumByLineType = (lineType) =>
    sectionLines.filter((l) => l.line_type === lineType).reduce((s, l) => s + (parseFloat(l.invoice_amount) || 0), 0);

  const docAwareVariance = isOutgoing
    ? (budgetSectionTotal || 0) - sumByLineType('PROFORMA_INVOICE') - sumByLineType('OUTGOING_INVOICE') + sumByLineType('CREDIT_NOTE')
    : (budgetSectionTotal || 0) - sumByLineType('PURCHASE_ORDER') - sumByLineType('INCOMING_INVOICE') + sumByLineType('DEBIT_NOTE');

  const subtotal = {
    invoice_amount: computeSubtotal('invoice_amount'),
    converted_amount_usd: computeSubtotal('converted_amount_usd'),
    amount_paid: computeSubtotal('amount_paid'),
    amount_open: computeSubtotal('amount_open'),
    budget_amount: budgetSectionTotal || 0,
    budget_variance: docAwareVariance,
  };

  const handleAdd = (lineType) => {
    const typeConfig = docTypes.find((dt) => dt.value === lineType);
    onAddRow({
      id: nextTempId(),
      line_type: lineType,
      line_label: typeConfig?.label || lineType,
      line_type_label: typeConfig?.label || lineType,
      classification: null,
      partner: '',
      description: '',
      invoice_date: null,
      invoice_currency: 'USD',
      invoice_amount: '',
      converted_amount_usd: 0,
      fx_rate_used: null,
      amount_paid: '',
      amount_open: 0,
      budget_amount: 0,
      budget_variance: 0,
      due_date: null,
      paid_date: null,
      is_system_line: false,
    });
  };

  return (
    <>
      {docTypes.map((dt) => {
        const typeLines = sectionLines.filter((l) => l.line_type === dt.value);

        if (typeLines.length === 0) {
          return (
            <React.Fragment key={dt.value}>
              <tr className="fc-data-row fc-empty-type-row">
                <td className="fc-type-cell">
                  <span className="fc-line-label">{dt.label}</span>
                </td>
                <td colSpan="16">
                  <button
                    className="fc-add-inline-btn"
                    onClick={() => handleAdd(dt.value)}
                    title="Invoice entries sync automatically. Use for ad-hoc entries only."
                  >
                    <i className="fas fa-plus"></i> Add entry
                  </button>
                </td>
              </tr>
            </React.Fragment>
          );
        }

        return (
          <React.Fragment key={dt.value}>
            {typeLines.map((line) => (
              <FinanceRow
                key={line.id}
                line={{ ...line, line_type_label: dt.label }}
                classifications={classifications}
                onChange={onLineChange}
                onRemove={onRemoveRow}
                showClassify={true}
                fxLoading={fxLoadingMap?.[line.id] || false}
                quantity={quantity}
              />
            ))}
            <tr className="fc-add-row-tr">
              <td colSpan="17">
                <button className="fc-add-btn" onClick={() => handleAdd(dt.value)} title="Invoice entries sync automatically. Use for ad-hoc entries only.">
                  <i className="fas fa-plus"></i> Add {dt.label}
                </button>
              </td>
            </tr>
          </React.Fragment>
        );
      })}

      <FinanceRow line={subtotal} isSubtotalRow={true} classifications={[]} onChange={() => {}} onRemove={() => {}} showClassify={false} quantity={quantity} />
    </>
  );
};

export { OUTGOING_TYPES, INCOMING_TYPES };
export default ActualsSection;
